// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Authentication_CollaboratorFragment = { __typename?: 'Collaborator', id: string };

export type Authentication_EmployeeFragment = { __typename?: 'Employee', id: string, isAdmin?: boolean | null, tier: Types.EmployeeTier, teams?: Array<{ __typename?: 'Team', id: string }> | null };

export type Authentication_ApplicationAuthorizationFragment = { __typename?: 'ApplicationAuthorization', userKind: Types.UserKind, auditLogs: Types.AuthorizationLevel, households: Types.AuthorizationLevel, branding: Types.AuthorizationLevel, collaborators: Types.AuthorizationLevel, internalEmployees: Types.AuthorizationLevel, roles: Types.AuthorizationLevel, tenantPresentationTemplates: Types.AuthorizationLevel, canActAsRelationshipOwner: boolean, hasAllClientsAccess: boolean, canEditEstateWaterfall: boolean, canPresentEstateWaterfall: boolean, canEditDispositiveProvisions: boolean, canModifyGlobalCategories: boolean, canModifyPrompts: boolean, canAccessTenantReporting: boolean, canApproveLuminarySupportTeamAccess: boolean, canApprovePresentations: boolean, canManageOrganizationDisclaimers: boolean, canManageSFTP: boolean };

export type Authentication_UserFragment = { __typename?: 'User', nameWithLastInitial: string, lastName: string, initials: string, id: string, firstName: string, email: string, displayName: string, employees?: Array<(
    { __typename?: 'Employee' }
    & Authentication_EmployeeFragment
  )> | null, collaborators?: Array<(
    { __typename?: 'Collaborator' }
    & Authentication_CollaboratorFragment
  )> | null };

export type GetUserStateQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserStateQuery = { __typename?: 'Query', applicationAuthorization: (
    { __typename?: 'ApplicationAuthorization' }
    & Authentication_ApplicationAuthorizationFragment
  ), currentUser?: (
    { __typename?: 'User', id: string }
    & Authentication_UserFragment
  ) | null, isUserLoggedInToAddepar: { __typename?: 'IsLoggedInToAddepar', isTokenValid: boolean, isLoggedIn: boolean }, isUserLoggedInToBlackDiamond: { __typename?: 'IsLoggedIn', isTokenValid: boolean, isLoggedIn: boolean }, isUserLoggedInToOrion: { __typename?: 'IsLoggedIn', isLoggedIn: boolean, isTokenValid: boolean }, isUserLoggedInToEMoney: { __typename?: 'IsLoggedIn', isLoggedIn: boolean, isTokenValid: boolean }, isIntegrationUserLoggedInToAddepar: { __typename?: 'IsLoggedInToAddepar', isLoggedIn: boolean, isTokenValid: boolean }, isIntegrationUserLoggedInToBlackDiamond: { __typename?: 'IsLoggedIn', isLoggedIn: boolean, isTokenValid: boolean }, isIntegrationUserLoggedInToEMoney: { __typename?: 'IsLoggedIn', isLoggedIn: boolean, isTokenValid: boolean }, isIntegrationUserLoggedInToOrion: { __typename?: 'IsLoggedIn', isLoggedIn: boolean, isTokenValid: boolean } };

export const Operations = {
  Query: {
    GetUserState: 'GetUserState' as const
  },
  Fragment: {
    Authentication_Collaborator: 'Authentication_Collaborator' as const,
    Authentication_Employee: 'Authentication_Employee' as const,
    Authentication_ApplicationAuthorization: 'Authentication_ApplicationAuthorization' as const,
    Authentication_User: 'Authentication_User' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const Authentication_ApplicationAuthorizationFragmentDoc = gql`
    fragment Authentication_ApplicationAuthorization on ApplicationAuthorization {
  userKind
  auditLogs
  households
  branding
  collaborators
  internalEmployees
  roles
  tenantPresentationTemplates
  canActAsRelationshipOwner
  hasAllClientsAccess
  canEditEstateWaterfall
  canPresentEstateWaterfall
  canEditDispositiveProvisions
  canModifyGlobalCategories
  canModifyPrompts
  canAccessTenantReporting
  canApproveLuminarySupportTeamAccess
  canApprovePresentations
  canManageOrganizationDisclaimers
  canManageSFTP
}
    `;
export const Authentication_EmployeeFragmentDoc = gql`
    fragment Authentication_Employee on Employee {
  id
  isAdmin
  tier
  teams {
    id
  }
}
    `;
export const Authentication_CollaboratorFragmentDoc = gql`
    fragment Authentication_Collaborator on Collaborator {
  id
}
    `;
export const Authentication_UserFragmentDoc = gql`
    fragment Authentication_User on User {
  nameWithLastInitial
  lastName
  initials
  id
  firstName
  email
  displayName
  employees {
    ...Authentication_Employee
  }
  collaborators {
    ...Authentication_Collaborator
  }
}
    ${Authentication_EmployeeFragmentDoc}
${Authentication_CollaboratorFragmentDoc}`;
export const GetUserStateDocument = gql`
    query GetUserState {
  applicationAuthorization {
    ...Authentication_ApplicationAuthorization
  }
  currentUser {
    id
    ...Authentication_User
  }
  isUserLoggedInToAddepar {
    isTokenValid
    isLoggedIn
  }
  isUserLoggedInToBlackDiamond {
    isTokenValid
    isLoggedIn
  }
  isUserLoggedInToOrion {
    isLoggedIn
    isTokenValid
  }
  isUserLoggedInToEMoney {
    isLoggedIn
    isTokenValid
  }
  isIntegrationUserLoggedInToAddepar {
    isLoggedIn
    isTokenValid
  }
  isIntegrationUserLoggedInToBlackDiamond {
    isLoggedIn
    isTokenValid
  }
  isIntegrationUserLoggedInToEMoney {
    isLoggedIn
    isTokenValid
  }
  isIntegrationUserLoggedInToOrion {
    isLoggedIn
    isTokenValid
  }
}
    ${Authentication_ApplicationAuthorizationFragmentDoc}
${Authentication_UserFragmentDoc}`;

/**
 * __useGetUserStateQuery__
 *
 * To run a query within a React component, call `useGetUserStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserStateQuery(baseOptions?: Apollo.QueryHookOptions<GetUserStateQuery, GetUserStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserStateQuery, GetUserStateQueryVariables>(GetUserStateDocument, withFetchPolicyContext(options));
      }
export function useGetUserStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserStateQuery, GetUserStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserStateQuery, GetUserStateQueryVariables>(GetUserStateDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetUserStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserStateQuery, GetUserStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserStateQuery, GetUserStateQueryVariables>(GetUserStateDocument, withFetchPolicyContext(options));
        }
export type GetUserStateQueryHookResult = ReturnType<typeof useGetUserStateQuery>;
export type GetUserStateLazyQueryHookResult = ReturnType<typeof useGetUserStateLazyQuery>;
export type GetUserStateSuspenseQueryHookResult = ReturnType<typeof useGetUserStateSuspenseQuery>;
export type GetUserStateQueryResult = Apollo.QueryResult<GetUserStateQuery, GetUserStateQueryVariables>;